import { fmt } from "./fmt";

export default function DetailRow({ icon: Icon, label, value }) {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-blue-100 bg-white p-3">
      <div className="rounded-xl bg-blue-50 p-2 text-blue-700">
        <Icon className="h-4 w-4" />
      </div>
      <div className="min-w-0">
        <p className="text-xs font-semibold text-slate-500">{label}</p>
        <p className="break-words text-sm font-semibold text-slate-900">{fmt(value)}</p>
      </div>
    </div>
  );
}